/* ============================================
   PSYCHIC LIORA — Landing Page Scripts
   ============================================ */

(function() {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Scroll Reveal --- */
  function initScrollReveal() {
    var reveals = document.querySelectorAll('.pl-reveal');
    if (!reveals.length) return;

    if (prefersReducedMotion) {
      reveals.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

    reveals.forEach(function(el) { observer.observe(el); });
  }

  /* --- Announcement Bar Auto-Rotate --- */
  function initAnnouncementRotate() {
    var bar = document.querySelector('.pl-announcement');
    if (!bar) return;

    var messages = bar.querySelectorAll('.pl-announcement__msg');
    if (messages.length <= 1) return;

    var current = 0;
    setInterval(function() {
      messages[current].classList.remove('is-active');
      current = (current + 1) % messages.length;
      messages[current].classList.add('is-active');
    }, 4000);
  }

  /* --- Dynamic Star Generation (Canvas) --- */
  function initStarCanvas() {
    var canvas = document.getElementById('pl-star-canvas');
    if (!canvas) return;

    if (prefersReducedMotion) {
      canvas.style.display = 'none';
      return;
    }

    var ctx = canvas.getContext('2d');
    var width, height, stars, constellationLines, shootingStars;
    var animId = null;
    var isMobile = window.innerWidth < 768;

    var lastDrawTime = 0;
    var frameBudget = isMobile ? 33 : 16;

    function resize() {
      width = canvas.width = window.innerWidth;
      height = canvas.height = document.documentElement.scrollHeight;
      isMobile = window.innerWidth < 768;
      frameBudget = isMobile ? 33 : 16;
    }

    /* Draw a 4-point star shape */
    function drawStarShape(x, y, size, color) {
      var inner = size * 0.35;
      ctx.beginPath();
      ctx.moveTo(x, y - size);
      ctx.lineTo(x + inner, y - inner);
      ctx.lineTo(x + size, y);
      ctx.lineTo(x + inner, y + inner);
      ctx.lineTo(x, y + size);
      ctx.lineTo(x - inner, y + inner);
      ctx.lineTo(x - size, y);
      ctx.lineTo(x - inner, y - inner);
      ctx.closePath();
      ctx.fillStyle = color;
      ctx.fill();
    }

    function createStars() {
      stars = [];
      var density = isMobile ? 10000 : 2500;
      var maxStars = isMobile ? 250 : 900;
      var count = Math.floor((width * height) / density);
      count = Math.min(count, maxStars);

      for (var i = 0; i < count; i++) {
        var sizeRoll = Math.random();
        var radius;
        if (sizeRoll < 0.55) {
          radius = Math.random() * 0.7 + 0.2;   // tiny dot: 0.2–0.9
        } else if (sizeRoll < 0.78) {
          radius = Math.random() * 1.0 + 0.9;   // medium: 0.9–1.9
        } else if (sizeRoll < 0.92) {
          radius = Math.random() * 1.2 + 1.9;   // large: 1.9–3.1
        } else {
          radius = Math.random() * 1.5 + 3.0;   // extra large: 3.0–4.5
        }

        // Decide shape: dots for small, mix of dots and stars for larger
        var shape = 'dot';
        if (radius > 1.5 && Math.random() < 0.5) {
          shape = 'star';
        }

        stars.push({
          x: Math.random() * width,
          y: Math.random() * height,
          r: radius,
          shape: shape,
          alpha: Math.random() * 0.5 + 0.3,
          speed: Math.random() * 0.005 + 0.002,
          phase: Math.random() * Math.PI * 2,
          isGold: Math.random() < 0.25
        });
      }
    }

    function createConstellationLines() {
      constellationLines = [];
      var lineCount = Math.floor(stars.length / 12);

      for (var i = 0; i < lineCount; i++) {
        var a = stars[Math.floor(Math.random() * stars.length)];
        var closest = null;
        var closestDist = Infinity;

        for (var j = 0; j < stars.length; j++) {
          var b = stars[j];
          if (b === a) continue;
          var dx = b.x - a.x;
          var dy = b.y - a.y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 200 && dist < closestDist) {
            closest = b;
            closestDist = dist;
          }
        }

        if (closest) {
          constellationLines.push({ a: a, b: closest });
        }
      }
    }

    /* --- Shooting Stars --- */
    function createShootingStars() {
      shootingStars = [];
    }

    function maybeSpawnShootingStar() {
      if (shootingStars.length >= 2) return;
      if (Math.random() > 0.003) return; // rare spawn each frame

      shootingStars.push({
        x: Math.random() * width * 0.8,
        y: Math.random() * height * 0.4,
        vx: 4 + Math.random() * 4,
        vy: 1.5 + Math.random() * 2,
        life: 0,
        maxLife: 40 + Math.random() * 30,
        length: 60 + Math.random() * 80,
        isGold: Math.random() < 0.4
      });
    }

    function drawShootingStars() {
      for (var i = shootingStars.length - 1; i >= 0; i--) {
        var ss = shootingStars[i];
        ss.x += ss.vx;
        ss.y += ss.vy;
        ss.life++;

        var progress = ss.life / ss.maxLife;
        var fade = progress < 0.2 ? progress * 5 : (1 - progress) * 1.25;
        fade = Math.max(0, Math.min(1, fade));

        var tailX = ss.x - ss.vx * (ss.length / ss.vx);
        var tailY = ss.y - ss.vy * (ss.length / ss.vx);

        var grad = ctx.createLinearGradient(tailX, tailY, ss.x, ss.y);
        if (ss.isGold) {
          grad.addColorStop(0, 'rgba(212, 175, 55, 0)');
          grad.addColorStop(0.7, 'rgba(212, 175, 55, ' + (fade * 0.4) + ')');
          grad.addColorStop(1, 'rgba(255, 235, 150, ' + (fade * 0.9) + ')');
        } else {
          grad.addColorStop(0, 'rgba(255, 255, 255, 0)');
          grad.addColorStop(0.7, 'rgba(255, 255, 255, ' + (fade * 0.3) + ')');
          grad.addColorStop(1, 'rgba(255, 255, 255, ' + (fade * 0.8) + ')');
        }

        ctx.beginPath();
        ctx.moveTo(tailX, tailY);
        ctx.lineTo(ss.x, ss.y);
        ctx.strokeStyle = grad;
        ctx.lineWidth = 1.5;
        ctx.stroke();

        // Bright head
        ctx.beginPath();
        ctx.arc(ss.x, ss.y, 1.5, 0, Math.PI * 2);
        ctx.fillStyle = ss.isGold
          ? 'rgba(255, 235, 150, ' + fade + ')'
          : 'rgba(255, 255, 255, ' + fade + ')';
        ctx.fill();

        if (ss.life >= ss.maxLife) {
          shootingStars.splice(i, 1);
        }
      }
    }

    function draw(time) {
      animId = requestAnimationFrame(draw);

      if (time - lastDrawTime < frameBudget) return;
      lastDrawTime = time;

      ctx.clearRect(0, 0, width, height);

      // Constellation lines
      ctx.strokeStyle = 'rgba(212, 175, 55, 0.08)';
      ctx.lineWidth = 0.5;
      for (var l = 0; l < constellationLines.length; l++) {
        var line = constellationLines[l];
        ctx.beginPath();
        ctx.moveTo(line.a.x, line.a.y);
        ctx.lineTo(line.b.x, line.b.y);
        ctx.stroke();
      }

      // Stars — dots and star shapes
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        var twinkle = Math.sin(time * s.speed + s.phase) * 0.3 + 0.7;
        var alpha = s.alpha * twinkle;

        var colorBase = s.isGold ? '212, 175, 55' : '255, 255, 255';

        if (s.shape === 'star') {
          // Draw 4-point star shape
          drawStarShape(s.x, s.y, s.r * 1.8, 'rgba(' + colorBase + ', ' + alpha + ')');
          // Soft glow behind star shape
          if (!isMobile) {
            ctx.beginPath();
            ctx.arc(s.x, s.y, s.r * 3.5, 0, Math.PI * 2);
            ctx.fillStyle = 'rgba(' + colorBase + ', ' + (alpha * 0.08) + ')';
            ctx.fill();
          }
        } else {
          // Regular dot
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(' + colorBase + ', ' + alpha + ')';
          ctx.fill();

          // Glow on medium+ dots (desktop only)
          if (!isMobile && s.r > 1.2) {
            ctx.beginPath();
            ctx.arc(s.x, s.y, s.r * 3, 0, Math.PI * 2);
            ctx.fillStyle = 'rgba(' + colorBase + ', ' + (alpha * 0.1) + ')';
            ctx.fill();
          }

          // Cross/spike on large dots (desktop only)
          if (!isMobile && s.r > 2.5) {
            var spikeLen = s.r * 3.5;
            ctx.strokeStyle = 'rgba(' + colorBase + ', ' + (alpha * 0.18) + ')';
            ctx.lineWidth = 0.5;
            ctx.beginPath();
            ctx.moveTo(s.x - spikeLen, s.y);
            ctx.lineTo(s.x + spikeLen, s.y);
            ctx.moveTo(s.x, s.y - spikeLen);
            ctx.lineTo(s.x, s.y + spikeLen);
            ctx.stroke();
          }
        }
      }

      // Shooting stars
      maybeSpawnShootingStar();
      drawShootingStars();
    }

    resize();
    createStars();
    createConstellationLines();
    createShootingStars();
    animId = requestAnimationFrame(draw);

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        if (animId) { cancelAnimationFrame(animId); animId = null; }
      } else {
        if (!animId) { animId = requestAnimationFrame(draw); }
      }
    });

    var resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        resize();
        createStars();
        createConstellationLines();
      }, 250);
    });
  }

  /* --- Init on DOM Ready --- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ============================================
     CART FLOW: CTA → Step 1 (Offers) → Step 2 (Questions) → Slide Cart (Bumps) → Checkout
     ============================================ */

  function initCartFlow() {
    var overlay = document.getElementById('pl-intake-overlay');
    var modal = document.getElementById('pl-intake-modal');
    var closeBtn = document.getElementById('pl-intake-close');
    var form = document.getElementById('pl-intake-form');
    var cartOverlay = document.getElementById('pl-cart-overlay');
    var cart = document.getElementById('pl-slide-cart');
    var cartClose = document.getElementById('pl-cart-close');
    var checkoutBtn = document.getElementById('pl-cart-checkout');

    if (!modal || !cart) return;

    var intakeData = {};
    var selectedPlan = 'subscription';
    var bumps = { enhanced: true, priority: false, express: false };

    /* --- Step navigation --- */
    var steps = modal.querySelectorAll('.pl-intake-step');
    var dots = modal.querySelectorAll('.pl-intake-step-dot');

    function goToStep(n) {
      steps.forEach(function(s) { s.classList.remove('is-active'); });
      dots.forEach(function(d, i) {
        d.classList.remove('is-active');
        d.classList.toggle('is-done', (i + 1) < n);
      });
      var target = modal.querySelector('.pl-intake-step[data-step="' + n + '"]');
      var dot = modal.querySelector('.pl-intake-step-dot[data-step="' + n + '"]');
      if (target) target.classList.add('is-active');
      if (dot) dot.classList.add('is-active');
      modal.scrollTop = 0;
    }

    /* Step 1 → Step 2 */
    var step1Continue = document.getElementById('pl-step1-continue');
    if (step1Continue) {
      step1Continue.addEventListener('click', function() {
        goToStep(2);
        /* Reset button text to default when going through normal flow */
        if (submitBtn) submitBtn.textContent = 'Save and Add to Cart';
        setTimeout(checkFormValid, 50);
      });
    }

    /* Step 2 → Back to Step 1 */
    var step2Back = document.getElementById('pl-step2-back');
    if (step2Back) {
      step2Back.addEventListener('click', function() { goToStep(1); });
    }

    /* --- Open intake modal from ANY CTA on the page --- */
    document.addEventListener('click', function(e) {
      var cta = e.target.closest('.pl-cta, .pl-cta--dual, [data-open-intake]');
      if (!cta) return;
      /* Don't intercept clicks inside modal or cart */
      if (cta.closest('.pl-intake-modal') || cta.closest('.pl-cart')) return;
      /* If the CTA has a real-page href (starts with / or http but not a hash anchor), let it navigate normally */
      var href = cta.getAttribute && cta.getAttribute('href');
      if (href && (href.indexOf('/') === 0 || href.indexOf('http') === 0) && href.indexOf('#') !== 0) return;
      e.preventDefault();
      openIntake();
    });

    function openIntake() {
      goToStep(1);
      overlay.classList.add('is-open');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      /* Check if browser restored form values */
      setTimeout(checkFormValid, 100);
    }

    function closeIntake() {
      overlay.classList.remove('is-open');
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    closeBtn.addEventListener('click', closeIntake);
    overlay.addEventListener('click', closeIntake);

    /* --- Plan selection in modal (Step 1) --- */
    var modalPlanSub = document.getElementById('pl-modal-plan-sub');
    var modalPlanOnce = document.getElementById('pl-modal-plan-once');

    function selectPlan(plan) {
      selectedPlan = plan;
      if (modalPlanSub) modalPlanSub.classList.toggle('is-selected', plan === 'subscription');
      if (modalPlanOnce) modalPlanOnce.classList.toggle('is-selected', plan === 'one-time');
      /* Update "you pay" in value stack */
      var youPay = document.getElementById('pl-modal-you-pay');
      if (youPay) youPay.textContent = plan === 'subscription' ? '$59.99' : '$79.99';
    }

    if (modalPlanSub) modalPlanSub.addEventListener('click', function() { selectPlan('subscription'); });
    if (modalPlanOnce) modalPlanOnce.addEventListener('click', function() { selectPlan('one-time'); });

    /* --- Auto-open modal from email redirects (?plan=one-time&open=1) --- */
    var urlParams = new URLSearchParams(window.location.search);
    var planParam = urlParams.get('plan');
    var openParam = urlParams.get('open');
    if (planParam === 'one-time' || planParam === 'subscription') {
      selectPlan(planParam);
    }
    if (openParam === '1') {
      setTimeout(function() { openIntake(); }, 250);
    }

    /* --- Real-time validation: enable/disable Add To Cart --- */
    var submitBtn = document.getElementById('pl-intake-submit');

    function checkFormValid() {
      var dobMonth = document.getElementById('pl-dob-month').value;
      var dobDay = document.getElementById('pl-dob-day').value;
      var dobYear = document.getElementById('pl-dob-year').value;
      var heartEl = document.getElementById('pl-on-your-heart');
      var heart = heartEl ? heartEl.value.trim() : '';

      var valid = dobMonth && dobDay && dobYear && dobYear.length >= 4 && heart.length > 0;

      if (submitBtn) {
        submitBtn.disabled = !valid;
        submitBtn.classList.toggle('pl-intake-btn--disabled', !valid);
      }
      return valid;
    }

    /* Listen to all form inputs for real-time validation */
    ['pl-dob-month', 'pl-dob-day', 'pl-dob-year', 'pl-on-your-heart'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) {
        el.addEventListener('input', checkFormValid);
        el.addEventListener('change', checkFormValid);
      }
    });

    /* --- Form submit → open slide cart --- */
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      form.querySelectorAll('.pl-intake-field--error').forEach(function(f) {
        f.classList.remove('pl-intake-field--error');
      });

      var valid = true;
      var dobMonth = document.getElementById('pl-dob-month').value;
      var dobDay = document.getElementById('pl-dob-day').value;
      var dobYear = document.getElementById('pl-dob-year').value;
      if (!dobMonth || !dobDay || !dobYear || dobYear.length < 4) {
        document.getElementById('pl-dob-month').closest('.pl-intake-field').classList.add('pl-intake-field--error');
        valid = false;
      }

      var heartEl = document.getElementById('pl-on-your-heart');
      var heart = heartEl ? heartEl.value.trim() : '';
      if (!heart) {
        if (heartEl) heartEl.closest('.pl-intake-field').classList.add('pl-intake-field--error');
        valid = false;
      }

      if (!valid) return;

      /* Show styled review modal before proceeding to cart.
         User must explicitly confirm or go back to add more. */
      var poiName = document.getElementById('pl-poi-name').value.trim();
      var poiDobMonthEl = document.getElementById('pl-poi-dob-month');
      var poiDobDayEl = document.getElementById('pl-poi-dob-day');
      var poiDobYearEl = document.getElementById('pl-poi-dob-year');
      var poiDobMonth = poiDobMonthEl ? poiDobMonthEl.value : '';
      var poiDobDay = poiDobDayEl ? poiDobDayEl.value : '';
      var poiDobYear = poiDobYearEl ? poiDobYearEl.value : '';
      var poiDob = (poiDobMonth && poiDobDay && poiDobYear && poiDobYear.length >= 4)
        ? (poiDobMonth + '/' + poiDobDay + '/' + poiDobYear)
        : '';
      var reviewOverlay = document.getElementById('pl-review-overlay');
      var poiNote = document.getElementById('pl-review-poi-note');
      if (poiNote) poiNote.classList.toggle('is-visible', !poiName);

      function proceedToCart() {
        intakeData = {
          'Date of Birth': dobMonth + '/' + dobDay + '/' + dobYear,
          'Person of Interest': poiName || 'Not provided',
          'Their Birthdate': poiDob || 'Not provided',
          'On Your Heart': heart
        };
        closeIntake();
        setTimeout(function() { openCart(intakeData, selectedPlan); }, 200);
      }

      if (reviewOverlay) {
        reviewOverlay.classList.add('is-open');
        reviewOverlay.setAttribute('aria-hidden', 'false');
        var confirmBtn = document.getElementById('pl-review-confirm');
        var backBtn = document.getElementById('pl-review-back');
        function closeReview() {
          reviewOverlay.classList.remove('is-open');
          reviewOverlay.setAttribute('aria-hidden', 'true');
        }
        function onConfirm() {
          confirmBtn.removeEventListener('click', onConfirm);
          backBtn.removeEventListener('click', onBack);
          closeReview();
          proceedToCart();
        }
        function onBack() {
          confirmBtn.removeEventListener('click', onConfirm);
          backBtn.removeEventListener('click', onBack);
          closeReview();
          if (heartEl) {
            setTimeout(function() {
              heartEl.focus();
              heartEl.setSelectionRange(heartEl.value.length, heartEl.value.length);
            }, 200);
          }
        }
        confirmBtn.addEventListener('click', onConfirm);
        backBtn.addEventListener('click', onBack);
      } else {
        /* Fallback: review modal not present, proceed directly */
        proceedToCart();
      }
    });

    /* --- Slide Cart --- */
    var timerInterval = null;
    var timerSeconds = 600;

    function openCart(intakeDataForCart, planForCart) {
      /* Sync cart display with selected plan */
      var basePriceEl = document.getElementById('pl-cart-base-price');
      if (basePriceEl) basePriceEl.innerHTML = selectedPlan === 'subscription' ? '$59.99<span class="pl-cart__item-price-period">/mo</span>' : '$79.99';

      /* Populate intake data into cart meta */
      if (window.plPopulateCartMeta) {
        window.plPopulateCartMeta(intakeDataForCart || intakeData, planForCart || selectedPlan);
      }

      /* Include optional note in intakeData for checkout */
      var noteEl = document.getElementById('pl-cart-note');
      if (noteEl) {
        noteEl.addEventListener('input', function() {
          intakeData['Optional Note'] = noteEl.value.trim();
        });
      }

      /* Show CLARITY25 discount banner if popup was submitted */
      var discountBanner = document.getElementById('pl-cart-discount');
      if (discountBanner) {
        var hasDiscount = localStorage.getItem('pl_popup_submitted');
        discountBanner.classList.toggle('is-visible', !!hasDiscount);
      }

      cartOverlay.classList.add('is-open');
      cart.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      startTimer();

      /* Add base product to Shopify cart immediately so native cart stays in sync */
      var config = window.plCartConfig || {};
      var baseVariant = selectedPlan === 'subscription'
        ? (config.baseProduct && config.baseProduct.variantId)
        : (config.oneTimeProduct && config.oneTimeProduct.variantId);
      if (baseVariant) {
        var properties = {};
        /* Prefix intake data with _ so it's hidden at checkout but captured on the order */
        for (var key in intakeData) {
          if (intakeData[key]) properties['_' + key] = intakeData[key];
        }
        properties['Plan'] = selectedPlan === 'subscription' ? 'Liora\'s Inner Circle (Monthly)' : 'One-Time Reading';
        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function() {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: baseVariant, quantity: 1, properties: properties }] })
            });
          })
          .then(function() {
            /* Update cart count badge if theme has one */
            var badge = document.querySelector('.cart-count-bubble span, [data-cart-count]');
            if (badge) badge.textContent = '1';
          })
          .catch(function(err) { console.error('Cart sync error:', err); });
      }
      updateTotal();
      updateDelivery();
    }

    function updateDelivery() {
      if (window.plUpdateDeliveryDate) {
        window.plUpdateDeliveryDate(selectedPlan, bumps.priority, bumps.express);
      }
    }

    function closeCart() {
      cartOverlay.classList.remove('is-open');
      cart.classList.remove('is-open');
      document.body.style.overflow = '';
      if (timerInterval) { clearInterval(timerInterval); timerInterval = null; }
    }

    cartClose.addEventListener('click', closeCart);
    cartOverlay.addEventListener('click', closeCart);

    /* Revisit questions — close cart, reopen intake at step 2 with "Save Questions" button */
    var revisitBtn = document.getElementById('pl-revisit-questions');
    if (revisitBtn) {
      revisitBtn.addEventListener('click', function() {
        closeCart();
        setTimeout(function() {
          goToStep(2);
          /* Change button text to "Save Questions" when revisiting */
          if (submitBtn) submitBtn.textContent = 'Save Questions';
          overlay.classList.add('is-open');
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          setTimeout(checkFormValid, 100);
        }, 250);
      });
    }

    function startTimer() {
      timerSeconds = 600;
      updateTimerDisplay();
      if (timerInterval) clearInterval(timerInterval);
      timerInterval = setInterval(function() {
        timerSeconds--;
        if (timerSeconds <= 0) { clearInterval(timerInterval); timerSeconds = 0; }
        updateTimerDisplay();
      }, 1000);
    }

    function updateTimerDisplay() {
      var el = document.getElementById('pl-cart-timer');
      if (!el) return;
      var m = Math.floor(timerSeconds / 60);
      var s = timerSeconds % 60;
      el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    }

    /* --- Order bump toggles (click anywhere on bump row or toggle) --- */
    var bumpEnhanced = document.getElementById('pl-bump-enhanced');
    var bumpPriority = document.getElementById('pl-bump-priority');
    var bumpExpress = document.getElementById('pl-bump-express');
    var toggleEnhanced = document.getElementById('pl-toggle-enhanced');
    var togglePriority = document.getElementById('pl-toggle-priority');
    var toggleExpress = document.getElementById('pl-toggle-express');

    var bumpEls = { enhanced: bumpEnhanced, priority: bumpPriority, express: bumpExpress };
    var toggleEls = { enhanced: toggleEnhanced, priority: togglePriority, express: toggleExpress };

    function toggleBump(name) {
      bumps[name] = !bumps[name];

      /* Express and Priority 12H are mutually exclusive — enabling one disables the other */
      if (name === 'express' && bumps.express) {
        bumps.priority = false;
        if (bumpEls.priority) bumpEls.priority.classList.remove('is-selected');
        if (toggleEls.priority) toggleEls.priority.classList.remove('is-on');
      } else if (name === 'priority' && bumps.priority) {
        bumps.express = false;
        if (bumpEls.express) bumpEls.express.classList.remove('is-selected');
        if (toggleEls.express) toggleEls.express.classList.remove('is-on');
      }

      if (bumpEls[name]) bumpEls[name].classList.toggle('is-selected', bumps[name]);
      if (toggleEls[name]) toggleEls[name].classList.toggle('is-on', bumps[name]);
      updateTotal();
      updateDelivery();
    }

    if (bumpEnhanced) bumpEnhanced.addEventListener('click', function() { toggleBump('enhanced'); });
    if (bumpPriority) bumpPriority.addEventListener('click', function() { toggleBump('priority'); });
    if (bumpExpress) bumpExpress.addEventListener('click', function() { toggleBump('express'); });

    /* Update total */
    function updateTotal() {
      var config = window.plCartConfig || {};
      var total = selectedPlan === 'subscription'
        ? (config.baseProduct && config.baseProduct.price) || 5999
        : (config.oneTimeProduct && config.oneTimeProduct.price) || 7999;

      if (bumps.enhanced) total += (config.enhancedProduct && config.enhancedProduct.price) || 1999;
      if (bumps.priority) total += (config.priorityProduct && config.priorityProduct.price) || 999;
      if (bumps.express) total += (config.expressProduct && config.expressProduct.price) || 2999;

      var el = document.getElementById('pl-cart-total');
      if (el) el.textContent = '$' + (total / 100).toFixed(2);
    }

    /* Checkout — base product already in cart, just sync bumps and go */
    checkoutBtn.addEventListener('click', function() {
      var config = window.plCartConfig || {};
      checkoutBtn.disabled = true;
      checkoutBtn.innerHTML = '<span>Processing...</span>';

      /* Build full cart: clear → add base + any bumps */
      var items = [];
      var baseVariant = selectedPlan === 'subscription'
        ? (config.baseProduct && config.baseProduct.variantId)
        : (config.oneTimeProduct && config.oneTimeProduct.variantId);

      if (baseVariant) {
        var properties = {};
        /* Prefix intake data with _ so it's hidden at checkout but captured on the order */
        for (var key in intakeData) {
          if (intakeData[key]) properties['_' + key] = intakeData[key];
        }
        /* Include optional note — visible */
        var noteEl = document.getElementById('pl-cart-note');
        if (noteEl && noteEl.value.trim()) {
          properties['_Optional Note'] = noteEl.value.trim();
        }
        properties['Plan'] = selectedPlan === 'subscription' ? 'Liora\'s Inner Circle (Monthly)' : 'One-Time Reading';
        items.push({ id: baseVariant, quantity: 1, properties: properties });
      }

      if (bumps.enhanced && config.enhancedProduct && config.enhancedProduct.variantId) {
        items.push({ id: config.enhancedProduct.variantId, quantity: 1 });
      }
      if (bumps.priority && config.priorityProduct && config.priorityProduct.variantId) {
        items.push({ id: config.priorityProduct.variantId, quantity: 1 });
      }
      if (bumps.express && config.expressProduct && config.expressProduct.variantId) {
        items.push({ id: config.expressProduct.variantId, quantity: 1 });
      }

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        })
        .then(function() {
          var hasDiscount = localStorage.getItem('pl_popup_submitted');
          window.location.href = hasDiscount ? '/discount/CLARITY25?redirect=/checkout' : '/checkout';
        })
        .catch(function(err) {
          console.error('Checkout error:', err);
          checkoutBtn.disabled = false;
          checkoutBtn.innerHTML = 'Secure Checkout';
          alert('Something went wrong. Please try again.');
        });
    });

    /* Close on Escape */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (modal.classList.contains('is-open')) closeIntake();
        if (cart.classList.contains('is-open')) closeCart();
      }
    });

    /* Dev preview: add ?cart=preview to URL to open cart directly */
    if (new URLSearchParams(window.location.search).get('cart') === 'preview') {
      setTimeout(function() {
        var dummyData = {
          'Date of Birth': '01/15/1990',
          'Person of Interest': 'Test',
          'On Your Heart': 'Preview mode'
        };
        openCart(dummyData, 'subscription');
      }, 500);
    }
  }

  /* --- Inject delivery date under every CTA on the page --- */
  function initDeliveryDates() {
    var d = new Date(Date.now() + 24 * 60 * 60 * 1000);
    var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var dateStr = days[d.getDay()] + ', ' + months[d.getMonth()] + ' ' + d.getDate();

    /* Populate modal delivery date */
    var modalDate = document.getElementById('pl-modal-delivery-date');
    if (modalDate) modalDate.textContent = dateStr;

    /* Inject under every CTA that doesn't already have one (skip product-info, it has its own) */
    document.querySelectorAll('.pl-cta').forEach(function(cta) {
      /* Skip if inside modal, cart, or product-info (already has one) */
      if (cta.closest('.pl-intake-modal') || cta.closest('.pl-cart') || cta.closest('.pl-product-info')) return;
      /* Skip if parent already has a delivery element */
      var parent = cta.parentElement;
      if (parent.querySelector('.pl-cta-delivery')) return;

      var div = document.createElement('div');
      div.className = 'pl-cta-delivery';
      div.innerHTML = '<span class="pl-cta-delivery__dot"></span> Receive your reading by <strong>' + dateStr + '</strong>';
      parent.insertBefore(div, cta.nextSibling);
    });
  }

  function init() {
    initStarCanvas();
    initScrollReveal();
    initAnnouncementRotate();
    initCartFlow();
    initDeliveryDates();
  }
})();
